import { Vraag, Vragenboom, Controltype, Vraagtype, Antwoord, BmSimulatie, BeschadigdeVoertuig, IndienenVragenboomResponse } from '@models/claims';
import { ConditionMapper } from '@models/mappers';
import { SharedData } from '@models/shareddata';
import { SharedDataService } from '@services/public_api';
import { Observable, Subject } from 'rxjs';

export class VragenboomMapper {
  public static mapIndienen(indienenResponse: IndienenVragenboomResponse): IndienenVragenboomResponse {
    if (!indienenResponse || !indienenResponse.vragenboom || !indienenResponse.vragenboom.vragen) {
      return indienenResponse;
    }

    indienenResponse = this.lijsten(indienenResponse);
    indienenResponse.vragenboom = this.map(indienenResponse.vragenboom);
    return indienenResponse;
  }

  public static map(vragenboom: Vragenboom): Vragenboom {
    if (!vragenboom || !vragenboom.vragen) {
      return vragenboom;
    }

    vragenboom.vragen = this.bundleLabelQuestions(vragenboom.vragen);
    this.populateConditions(vragenboom.vragen);
    return vragenboom;
  }

  private static bundleLabelQuestions(vragen: Vraag[]): Vraag[] {
    if (!vragen) {
      return;
    }

    if (vragen.length > 0) {
      vragen = this.mergeLabelVragen(vragen);
      vragen = this.combineFirstLabelQuestion(vragen);
    }

    return vragen;
  }

  private static lijsten(indienenResponse: IndienenVragenboomResponse): IndienenVragenboomResponse {
    if (!indienenResponse) {
      return indienenResponse;
    }
  
    indienenResponse.vragenboom?.vragen.forEach((vr: Vraag) => {
      if (vr.control === Controltype.Label && vr.antwoorden?.length > 0) {
        vr.antwoorden.forEach((antw: Antwoord) => {
          if (antw.soortLijst?.bmSimulaties) {
            indienenResponse.BMSimulaties = antw.soortLijst.bmSimulaties as BmSimulatie[];
          }
          if (antw.soortLijst?.berekening) {
            indienenResponse.berekening = antw.soortLijst.berekening;
          }
          if (antw.soortLijst?.beschadigdeVoertuigen) {
            indienenResponse.beschadigdeVoertuigen = antw.soortLijst.beschadigdeVoertuigen;
          }
          if (antw.soortLijst?.limietenEnEigenRisicos) {
            indienenResponse.limietenEnEigenRisicos = antw.soortLijst.limietenEnEigenRisicos;
          }
        });
      }
    });

    return indienenResponse;
  }

  private static combineFirstLabelQuestion(vragen: Vraag[]): Vraag[] {
    if (!vragen) {
      return;
    }

    const startLabel = vragen.find(v => v.control === Controltype.Label && v.startvraag);
    if (startLabel) {
      const nextQuestion = vragen.find(v => v.id === this.nextVraagId(startLabel));
      if (nextQuestion && nextQuestion.groep_id === startLabel.groep_id) {
        nextQuestion.startvraag = true;
        nextQuestion.messageVraag = startLabel;

        return vragen.filter(v => v.id !== startLabel.id);
      }
    }

    return vragen;
  }

  private static mergeLabelVragen(vragen: Vraag[]) {
    if (!vragen) {
      return;
    }

    const vragenToDelete = [];
    const labelVragen = vragen.filter(v => v.control === Controltype.Label);

    for (const vraag of labelVragen) {
      if (!vraag.connectedVragen) {
        vraag.connectedVragen = [];
      }

      if (vragenToDelete.findIndex(v => v.id === vraag.id) < 0) {
        let nextQuestion = labelVragen.find(v => v.id === this.nextVraagId(vraag) && v.tonen && v.groep_id === vraag.groep_id);

        while (nextQuestion) {
          vraag.connectedVragen.push(nextQuestion);
          vragenToDelete.push(nextQuestion);
          nextQuestion = labelVragen.find(v => v.id === this.nextVraagId(nextQuestion) && v.tonen && v.groep_id === vraag.groep_id);
        }

        if (vraag.connectedVragen?.length > 0) {
          const lastConnectedVraag = vraag.connectedVragen[vraag.connectedVragen.length - 1];
          let linktNaar = lastConnectedVraag.linkt_naar;
          if (!linktNaar && lastConnectedVraag.antwoorden && lastConnectedVraag.antwoorden.length > 0) {
            linktNaar = lastConnectedVraag.antwoorden[0].linkt_naar;
          }

          vraag.linkt_naar = linktNaar;
        }
      }
    }

    if (vragenToDelete.length > 0) {
      return vragen.filter(v => vragenToDelete.findIndex(d => d.id === v.id) < 0);
    }

    return vragen;
  }

  private static nextVraagId(vraag: Vraag): string {
    if (vraag == null || vraag.control !== Controltype.Label) {
      return null;
    }

    if (vraag.linkt_naar) {
      return vraag.linkt_naar;
    }

    if (vraag.antwoorden?.length === 1) {
      return vraag.antwoorden[0].linkt_naar;
    }

    return null;
  }

  private static populateConditions(vragen: Vraag[]) {
    if (!vragen)
      return;

    vragen.forEach(vraag => {
      vraag.conditions = ConditionMapper.map(vraag.id, vraag.linkt_naar);
    });
  }
}
